import React, {useRef} from "react";
import {
    Button,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Glyphicon,
    Panel,
    Row,
} from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import { quizFinalScreenUpdate } from "../../../../../../api/cp";

export default ({ quizId, isSaving, finalScreen, setProperty, onSave }) => {
    const imageInputRef = useRef(null);

    const savePicture = async (file) => {
        try {
            const formData = new FormData();
            formData.append('picture', file);
            const response = await quizFinalScreenUpdate(quizId, formData);
            setProperty('pictureUrl', response.pictureUrl);
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <>
            <Panel>
                <PanelHeading style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <PanelTitle>Заголовок</PanelTitle>
                </PanelHeading>
                <PanelBody>
                    <FormGroup>
                        <Row>
                            <Col xs={6}>
                                <ControlLabel>Заголовок [Ru]</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={finalScreen.titleRu}
                                    onChange={(e) => setProperty('titleRu', e.target.value)}
                                    onBlur={onSave}
                                    disabled={isSaving}
                                />
                            </Col>
                            <Col xs={6}>
                                <ControlLabel>Заголовок [En]</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={finalScreen.titleEn}
                                    onChange={(e) => setProperty('titleEn', e.target.value)}
                                    onBlur={onSave}
                                    disabled={isSaving}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </PanelBody>
            </Panel>
            <Panel>
                <PanelHeading style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <PanelTitle>Подзаголовок</PanelTitle>
                </PanelHeading>
                <PanelBody>
                    <FormGroup>
                        <Row>
                            <Col xs={6}>
                                <ControlLabel>Подзаголовок [Ru]</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={finalScreen.subtitleRu}
                                    onChange={(e) => setProperty('subtitleRu', e.target.value)}
                                    onBlur={onSave}
                                    disabled={isSaving}
                                />
                            </Col>
                            <Col xs={6}>
                                <ControlLabel>Подзаголовок [En]</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={finalScreen.subtitleEn}
                                    onChange={(e) => setProperty('subtitleEn', e.target.value)}
                                    onBlur={onSave}
                                    disabled={isSaving}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </PanelBody>
            </Panel>
            <Panel>
                <PanelHeading>
                    <PanelTitle>Изображение</PanelTitle>
                </PanelHeading>
                <PanelBody>
                    <FormGroup>
                        <Row>
                            <Col xs={6}>
                                {finalScreen.pictureUrl && <div><img src={finalScreen.pictureUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
                                <div>
                                    <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                                    {' '}
                                    {finalScreen.pictureUrl && <Button onClick={() => onSave('picture', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                                </div>
                                <FormControl
                                    type="file"
                                    onChange={(e) => savePicture(e.target.files[0] || null)}
                                    inputRef={ref => imageInputRef.current = ref}
                                    style={{ display: 'none' }}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </PanelBody>
            </Panel>
            <Panel>
                <PanelHeading style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <PanelTitle>Кнопка</PanelTitle>
                </PanelHeading>
                <PanelBody>
                    <FormGroup>
                        <Row>
                            <Col xs={6}>
                                <ControlLabel>Текст кнопки [Ru]</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={finalScreen.buttonTextRu}
                                    onChange={(e) => setProperty('buttonTextRu', e.target.value)}
                                    onBlur={onSave}
                                    disabled={isSaving}
                                />
                            </Col>
                            <Col xs={6}>
                                <ControlLabel>Текст кнопки [En]</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={finalScreen.buttonTextEn}
                                    onChange={(e) => setProperty('buttonTextEn', e.target.value)}
                                    onBlur={onSave}
                                    disabled={isSaving}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col xs={6}>
                                <ControlLabel>Ссылка</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={finalScreen.buttonUrl}
                                    onChange={(e) => setProperty('buttonUrl', e.target.value)}
                                    onBlur={onSave}
                                    disabled={isSaving}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </PanelBody>
            </Panel>
        </>
    )
}